<div class="ct" [class]="typeClass">
  <span class="material-symbols-outlined ct-icon">{{ icon }}</span>

  <div class="ct-body">
    <p class="ct-title">{{ label }}</p>
    <p class="ct-message" [innerHTML]="message"></p>
  </div>

  <button class="ct-close" (click)="remove()" type="button" aria-label="Dismiss">
    <span class="material-symbols-outlined">close</span>
  </button>

  <div class="ct-progress" *ngIf="options.progressBar">
    <div class="ct-progress-bar" [style.width]="width + '%'"></div>
  </div>
</div>
